import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL?.replace(/\/$/, '') || '';

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 15000
});

// Optional: simple response interceptor to unwrap data consistently
api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default api;
